import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import DetailContainer from "~/Containers/DetailContainer";
import CommentForm from "~/Components/Forms/Comment/CommentForm";
import CommentList from "~/Components/CommentList";
import RelatedPostsContainer from "~/Containers/RelatedPostsContainer";
import Tile from "../../Components/Tile";
import Spinner from "react-bootstrap/Spinner";

import styled from "styled-components";

export const PreviouslyPostedWrapper = styled.section`
  margin: 20px 0 10px 0;
  font-size: 14px;
  color: #333;
  text-align: right;
  font-weight: bold;
`;

const DetailPage = ({ match }) => {
  const { slug } = match.params;

  // @TODO props match slug url changes, it has to fetch new data

  return (
    <div className="home-page-component">
      <div>
        <DetailContainer
          slug={slug}
          render={({ item, date, loading, failure }) => (
            <Row>
              <Col xs={12}>
                {loading && (
                  <div className="container-loading">
                    <Spinner animation="border" size="sm" /> Loading...
                  </div>
                )}
                {!loading && !failure && (
                  <React.Fragment>
                    <Helmet>
                      <title>____ of the Day | {item.otd_title} of the Day | Dream Chimney</title>
                      <meta property="og:title" content={`"${item.otd_title}" of the Day | Dream Chimney`}></meta>
                      <meta property="og:description" content={`"${item.otd_title}" of the Day | Dream Chimney`}></meta>
                      {item && item.img_url && item.img_url !== "" && (
                        <meta property="og:image" content={`https://www.dreamchimney.com/${item.img_url}`}></meta>
                      )}
                      <meta property="og:url" content={`https://www.dreamchimney.com/oftheday/${slug}`}></meta>
                      <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/${slug}`} />
                    </Helmet>
                    {date && <PreviouslyPostedWrapper>Originally posted: {date}</PreviouslyPostedWrapper>}
                    <Tile archive={false} otd={item}>
                      <CommentForm postId={item.id} post={item}>
                        <CommentList />
                      </CommentForm>
                    </Tile>
                    <RelatedPostsContainer
                      id={item.id}
                      render={({ posts, loading, failure }) => {
                        if (posts.length === 0) return null;
                        return (
                          <div style={{ marginTop: "10px" }}>
                            <div className="pageTitle">Related Posts</div>
                            <Row noGutters className="minimalGutter">
                              {posts.map((post, i) => (
                                <Col xl={4} lg={6} xs={12} key={post.id}>
                                  <Tile archive otd={post} />
                                </Col>
                              ))}
                            </Row>
                          </div>
                        );
                      }}
                    />
                  </React.Fragment>
                )}
                {failure && (
                  <div style={{ paddingBottom: 80 }}>
                    <div className="pageTitle">This specific post was not found.</div>
                    <p>
                      But there are so many other similar ones. Try our{" "}
                      <Link to={`/search`} style={{ color: "white" }}>
                        search option
                      </Link>{" "}
                      for more good stuff.
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          )}
        />
      </div>
    </div>
  );
};

export default DetailPage;
